import styled from 'styled-components';

export const AlignRight = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  justify-content: right;
`;
